import { render, staticRenderFns } from "./WidgetPromoLogo.vue?vue&type=template&id=0c630e8f"
import script from "./WidgetPromoLogo.vue?vue&type=script&lang=js"
export * from "./WidgetPromoLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports